<div class="row mt-5">
  <div class="col-sm-8 col-md-6 col-lg-4 m-auto">
    <div
      class="card card-body"
      style="border-radius: 25px; padding-bottom: 60px"
    >
      <!-- <div style="display: flex; align-items: center;">
            <div class="home-icon" style="display: inline-block;">
                <svg xmlns="http://www.w3.org/2000/svg" width="30" fill="currentColor" class="bi bi-house-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"/>
                    <path fill-rule="evenodd" d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"/>
                </svg>
            </div>
          <div style="margin-left: 10px; margin-top: 0px; display: inline-block; font-weight: 400; font-size: 1.5em;">Welcome to IMT</div>
        </div> -->

      <!-- commenting out for now
        
      <h2 class="text-left" style="margin-top: 0px">Welcome to IMT</h2>-->
      
      <!-- Error message for route not found -->
      <div *ngIf="errorMessage" class="alert alert-warning" role="alert" style="margin-bottom: 20px;">
        {{ errorMessage }}
      </div>
      
       <!-- commenting out for now <div id="heading-text" class="text-left">I would like to...</div> -->

       <!-- commenting out for now <div
        class="btn btn-block"
        [routerLink]="optionsInCycle.includes('F') ? '/frq' : null"
        [class.disabled]="!optionsInCycle.includes('F')"
        [title]="
          !optionsInCycle.includes('F')
            ? 'The funding request questionnaire is not currently available'
            : ''
        "
      >
        Enter a funding request questionnaire
      </div> -->

      <div
        class="btn btn-block"
        [routerLink]="optionsInCycle.includes('S') && firstSurveyRoute ? firstSurveyRoute : null"
        [class.disabled]="!optionsInCycle.includes('S') || !firstSurveyRoute"
        [title]="
          !optionsInCycle.includes('S')
            ? 'The survey is not currently available'
            : !firstSurveyRoute
            ? 'Survey route is loading...'
            : ''
        "
      >
       <!-- commenting out for now Take the survey --> Go to Survey
      </div>
    </div>
  </div>
</div>
